import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {FlexCenter, FlexCenterVertically} from '~/shared/theme/FlexLayout';
import {smallBold} from '~/shared/theme/typography';
import ToggleSwitch from '~/shared/components/ToggleSwitch';
import {media} from '~/shared/theme/media';

const Root = styled.div`
  width: 100%;
`;

const Container = styled(FlexCenterVertically)`
  justify-content: space-between;
`;

const Label = styled.span``;

const ErrorContainer = styled(FlexCenter)`
  flex-direction: column;
  ${media.minLargeMobile`
    flex-direction: row;
  `}
`;

const ErrorText = styled.span`
  ${smallBold}
  display: block;
  color: ${({theme}) => theme.colors.error};
`;

const StyledToggleSwitch = styled(ToggleSwitch)`
  width: 40px;
  height: 24px;

  & > div {
    width: 20px;
    height: 20px;
    top: 2px;
    left: ${({isActive}: {isActive: boolean}) => (isActive ? '18px' : '2px')};
  }
`;

type ToggleSettingWithErrorProps = {
  label: string;
  isActive: boolean;
  hasError: boolean;
  onToggle: () => void;
  dataTestId: string;
  isMinLargeMobile?: boolean;
};

const ToggleSettingWithError = ({
  isActive,
  hasError,
  onToggle,
  label,
  dataTestId,
  isMinLargeMobile,
}: ToggleSettingWithErrorProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      <Container>
        <Label>{label}</Label>
        <ErrorContainer>
          {hasError && isMinLargeMobile && <ErrorText>{t('something_went_wrong_try_again_later')}</ErrorText>}
          <StyledToggleSwitch onClick={onToggle} dataTestId={dataTestId} isActive={isActive} />
        </ErrorContainer>
      </Container>
      {hasError && !isMinLargeMobile && <ErrorText>{t('something_went_wrong_try_again_later')}</ErrorText>}
    </Root>
  );
};

export default memo(ToggleSettingWithError);
